const answers = [
	{
		id: 1,
		heading: "آیا امکان ویرایش مشخصات کاربری و ایمیل من وجود دارد؟",
		details:
			'شما می‏‌توانید مشخصات کاربری خود را ویرایش کنید. برای این کار باید با وارد کردن پست الکترونیکی (یا شماره همراه در صورت تایید شماره همراه) و کلمه عبور، وارد حساب کاربری خود بشوید، سپس با کلیک روی گزینه "پروفایل من" به صفحه‏‌ای منتقل می‏‌شوید که در بخش "اطلاعات کاربر" امکان "ویرایش اطلاعات" وجود دارد.',
	},
	{
		id: 2,
		heading:
			"چرا با وجود درخواست من برای تغییر رمز حساب کاربری، لینک آن برای من ایمیل نشده است؟",
		details:
			"لطفاً ایمیل‌های اسپم(spam) خود را چک کنید. به ویژه ایمیل‌های ارسال شده به حساب‏‌های کاربری gmail گاهی spam می‌شوند. توجه داشته باشید که link تغییر رمز برای شما ارسال می‏‌شود نه خود رمز.",
	},
	{
		id: 3,
		heading: "آیا می‌‏توانم به اطلاعات خریدهای قبلی خود دسترسی داشته باشم؟",
		details:
			'برای دسترسی به اطلاعات خریدهای قبلی، باید با حساب کاربری خود وارد شوید، سپس روی گزینه "داشبورد" کلیک کنید تا سوابق خرید شما نشان داده ‏شود.',
	},
	{
		id: 4,
		heading:
			"دوست دارم از آنتی‌ویروس خرید کنم، اما هنوز کاملاً به خرید اینترنتی اعتماد ندارم، چگونه مطمئن باشم که پس از خرید، کالا به دست من می‌رسد؟",
		details:
			"دارا بودن نماد اعتماد الکترونیکی به این کسب و کار رسمیت و اعتبار می‏‌بخشد. نماد اعتماد الکترونیکی توسط مرکز توسعه تجارت الکترونیکی وزارت صنعت، معدن و تجارت پس از بررسی فروشگاه اینترنتی و تطابق نحوه عملکرد آن با قوانین، اعطا می‏‌شود و کسب و کار اینترنتی دارای نماد به صورت مداوم تحت بررسی این سازمان قرار دارد. برای اطمینان بیشتر شما می‏‌توانید در صفحه اصلی وب سایت آنتی ویروس با کلیک روی نماد از جعلی نبودن آن اطمینان پیدا کنید.",
	},
	{
		id: 5,
		heading: "آیا برای خرید، حتما باید در سایت عضو باشم؟",
		details:
			"بله، با این که بدون وارد شدن به سایت می‏‌توانید یک کالا را به سبد خرید اضافه کنید، اما برای انجام مراحل بعدی خرید و ثبت سفارش باید با حساب کاربری خود وارد سایت شده و یا در هنگام خرید، عضویت خود را تکمیل کنید.",
	},
	{
		id: 6,
		heading: "آیا در تمام ساعات شبانه روز می‌توانم سفارش خود را ثبت کنم؟",
		details:
			"شما در ۲۴ ساعت شبانه روز ۷ روز هفته می‌‏توانید سفارش خود را ثبت کنید.",
	},
	{
		id: 7,
		heading:
			"آیا می‌توانم با حساب کاربری خودم، خرید کنم و فاکتور به نام شخص حقوقی یا شرکت صادر شود؟",
		details:
			"بله، پس از انتخاب کالاهای موردنظر و اضافه کردن آنها به سبد خرید و اتمام عملیات خرید با پشتیبانی تماس بگیرید.",
	},
	{
		id: 8,
		heading: "از وضعیت سفارشی که ثبت کرده‏‌ام، چگونه می‌‏توانم مطلع شوم؟",
		details:
			' برای اطلاع از وضعیت سفارش، می‏‌توانید وارد حساب کاربری خود شوید و با کلیک روی گزینه "داشبورد" از وضعیت آن مطلع شوید.',
	},
	{
		id: 9,
		heading: "می‌‏توانم سفارشم را ابطال کنم یا تغییر بدهم؟",
		details:
			"تا پیش از تایید نهایی سفارش و پرداخت هزینه توسط درگاه بانک شما می‌توانید سفارش را از سبد خرید خود حذف و یا اصلاح کنید.",
	},
	{
		id: 10,
		heading:
			"بعد از ثبت سفارش، برای اطمینان از پردازش آن باید با آنتی ویروس تماس بگیرم؟",
		details:
			"خیر، پس از انجام مراحل خرید و ثبت سفارش، پردازش سفارش شما به صورت خودکار از طریق سرویس پیامک یا ایمیل اطلاع‏ رسانی خواهد شد و در صورتی که نیاز باشد کارشناسان فروش آنتی ویروس با شما تماس خواهند گرفت.",
	},
	{
		id: 11,
		heading: "می‏‌توانم سفارشم را تلفنی ثبت کنم؟",
		details:
			"خیر، به منظور تسریع فرایند پردازش و ارسال سفارش و نیز کاهش امکان بروز خطا در ثبت سفارش، مشتریان محترم ‏باید سفارش خود را اینترنتی ثبت کنند.",
	},
	{
		id: 12,
		heading: "آیا تعداد خرید از یک کالا محدودیتی دارد؟",
		details:
			"به طور کلی محدودیتی برای سفارش تعدادی یک کالا وجود ندارد، با وجود این با توجه به اینکه موجودی قابل فروش برای هر کالا در هر زمان متفاوت است، ",
	},
	{
		id: 13,
		heading: "مبلغ سفارشم را چگونه می‏‌توانم پرداخت کنم؟",
		details:
			"همگی کاربران می‌توانند از طریق درگاه اینترنتی و با استفاده از همه کارت‏‌های بانکی عضو شبکه شتاب، هزینه سفارش را به صورت آنلاین پرداخت کنند.",
	},

	{
		id: 14,
		heading:
			"با استفاده از کارت کدام بانک‌ها می‌توان هزینه سفارش را اینترنتی پرداخت کرد؟",
		details:
			"شما می‌توانید با استفاده از همه کارت‏‌های بانکی عضو شبکه شتاب هزینه سفارش را به صورت آنلاین پرداخت کنید.",
	},
	{
		id: 15,
		heading:
			"ممکن است پرداخت اینترنتی ناموفق باشد، ولی مبلغ از حساب من کم شده باشد؟",
		details:
			"گاهی ممکن است در هنگام پرداخت شبکه بانکی قطع شود و پرداخت ناموفق انجام شود. اما در این مواقع جای نگرانی وجود ندارد. در این حالت معمولاً پول شما در حساب‏‌های میانی بانک است و خود بانک مغایرت‏‌ها را رفع کرده و مبلغ را به صورت خودکار به حساب شما برگشت می‌‏دهد. اگر تا 72 ساعت پول به حسابتان برگشت نخورد، آنگاه با بانک عامل پرداخت اینترنتی تماس بگیرید تا مغایرت برطرف شود.",
	},
	{
		id: 16,
		heading:
			"می‏‌توانم کالایی را که سفارش داده‌‏ام با مراجعه به آنتی ویروس به صورت حضوری تحویل بگیرم؟",
		details:
			"بله، قبل از مراجعه با پشتیبانی تماس گرفته و هماهنگی‌های لازم را انجام دهید.",
	},
	{
		id: 17,
		heading:
			"پس از این که سفارشم را ثبت کردم، چقدر طول می‌‏کشد که به دستم برسد؟",
		details:
			"لایسنس آنتی ویروس شما پس از پرداخت پرداخت وجه به صورت آنی بر روی صفحه نمایش پیدا می‌کند.",
	},
	{
		id: 18,
		heading: "آیا قیمت محصولات در سایت به روز هستند؟",
		details:
			"بله، آنتی ویروس به طور منظم و روزانه قیمت‏ محصولات عرضه شده در وب‏ سایت خود را کنترل و به روز رسانی می‏‌کند.",
	},
	{
		id: 19,
		heading:
			"آیا آنتی‌ویروس در تهران یا سایر شهرها، شعبه دیگر یا نمایندگی دارد؟",
		details:
			"آنتی ویروس در هیچ نقطه‌‌ای از کشور نماینده فروش یا خدمات پس از فروش ندارد. کلیه سرویس‌‏ها و تراکنش‏‌های مالی و خدمات فروش قابل ارائه آنتی ویروس از طریق دفتر مرکزی تهران که آدرس آن در وب سایت مندرج است پردازش می‏‌شود. لطفاً در صورت مشاهده هر گونه تخلفی از این دست، مراتب را جهت پیگرد قانونی از طریق ایمیل info@antivirus.com به آنتی ویروس اطلاع دهید.",
	},
	{
		id: 20,
		heading: "آیا تمامی محصولات ارائه شده دارای گارانتی می‌باشد ؟",
		details:
			"تمامی محصولات ارائه شده توسط وب‌سایت دارای ۲ گارانتی می‌باشد، ابتدا تیم آنتی ویروس سعی به راهنمایی و حل مشکل می‌کنند سپس در صورت عدم حل مشکل شما به شرکت مربوطه متصل می‌شوید. در صورت حل نشدن مشکل توسط پشتیبانی شرکت ثانویه تا ۷۲ ساعت وجه پرداختی به حساب شما بازگردانده می‌شود.",
	},
]

export default answers
